import React from "react";
const IconLamp = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 16" {...props}>
    <path
      d="M10.799 12.085H7.045c0-1.52-3.058-2.37-3.058-5.765 0-2.587 2.399-4.92 4.92-4.92 2.52 0 4.92 2.002 4.92 4.92 0 3.386-3.028 4.247-3.028 5.765ZM11.188 14.6H6.625M8.905 12.53V8.047M10.332 14.6H7.48M10.652 8.047H7.16"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);
export default IconLamp;
